// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__Dlfyd","header":"Messages_header__326EV"};